export default {"src":"/_next/static/media/homepage_characters.69dc8d12.svg","height":2315,"width":3889};